import React from 'react';
import arrowIcon from '../../../assets/images/matchmaker-arrow.svg';

/**
 * Step 3 of the "Be a Matchmaker" flow — the matchmaker's own details.
 * Figma: "Your Details" (6:30)
 *
 * The lead copy diverges from the Figma text deliberately: the frame reads
 * "Enter your details and your relationship to [Name]", but relationship is
 * collected on step 2 and this screen has no such field. Do not restore it.
 */
const ReferrerDetailsComponent = ({
  goToNextStep,
  formValidation,
  values,
  handleChange,
  isSubmitting
}) => {

  // A real <form> so Enter submits from any field, not just the last one.
  // The submit button is disabled while in flight, which also blocks Enter.
  const onSubmit = (event) => {
    event.preventDefault();
    if (!isSubmitting) goToNextStep(4);
  };

  return (
    <div className="matchmakerWrapper mm-details">
      <div className="mm-content mm-content-form">
        <h1 className="mm-title mm-title-tight">Almost there…</h1>
        <p className="mm-lead">
          Enter your details so we can let {values.firstName} know you’ve
          recommended them to Lovrican.
        </p>

        <form className="mm-form-wrap" onSubmit={onSubmit}>
          <div className="mm-form mm-form-gap-lg">
            <div className="mm-form-row">
              <div className="mm-field">
                <input
                  className="mm-input"
                  type="text"
                  placeholder="First name"
                  value={values.pFirstName}
                  onChange={handleChange('pFirstName')}
                />
                <span className="validation-error">
                  {formValidation.pFirstName}
                </span>
              </div>
              <div className="mm-field">
                <input
                  className="mm-input"
                  type="text"
                  placeholder="Last name"
                  value={values.pLastName}
                  onChange={handleChange('pLastName')}
                />
                <span className="validation-error">
                  {formValidation.pLastName}
                </span>
              </div>
            </div>
            <div className="mm-form-row">
              <div className="mm-field">
                <input
                  className="mm-input"
                  type="email"
                  placeholder="Enter Email ID"
                  value={values.pEmail}
                  onChange={handleChange('pEmail')}
                />
                <span className="validation-error">{formValidation.pEmail}</span>
              </div>
            </div>
          </div>

          <div className="mm-actions">
            <button
              className="mm-next"
              type="submit"
              aria-label="Submit"
              disabled={isSubmitting}
            >
              <img src={arrowIcon} alt="" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReferrerDetailsComponent;
